import { FilterMatchMode } from "primereact/api"

export class ControlResponsable {
    model = {
        id: { value: null, export: false },
        idp: { value: null, export: false },
        revision: {
            header: 'CONTROLES PARA EL MONITOREO Y REVISIÓN DEL RIESGO',
            value: null,
            required: 'Selecione una opcion',
            optionLabel: 'nombre',
            export: false,
            filterPlaceholder: 'Búsqueda',
            filterField: 'revision',
            filter: true,
            sort: true,
            table: true,
            matchMode: FilterMatchMode.CONTAINS
        },
        responsable: {
            header: 'RESPONSABLES',
            value: null,
            required: 'Selecione una opcion',
            optionLabel: 'nombre',
            export: false,
            filterPlaceholder: 'Búsqueda',
            filterField: 'responsable',
            filter: true,
            sort: true,
            table: true,
            matchMode: FilterMatchMode.CONTAINS
        },
    }
}
